export default __webpack_public_path__ + "static/media/sicilian-sweets.f118d014.jpg";